import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';
import AuthenticationUtil from '../../util/AuthenticationUtil';
import NullCheckUtil from '../../util/NullCheckUtil';
import SessionStorageUtil from '../../util/SessionStorageUtil';
import { request } from '../ApiModule';
import { List } from '@material-ui/core';

const BASE = 'modal/ENROLMENT_CAUTION';
const ACTION_SEARCH = BASE + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_CHECK = BASE + PATH_DELIMITER + 'ACTION_CHECK';
const ACTION_LIST_SEARCH = BASE + PATH_DELIMITER + 'ACTION_LIST_SEARCH';
const HANDLE_DATA = BASE + PATH_DELIMITER + 'HANDLE_DATA';
const HANDLE_NOTIFICATON_DATA = BASE + PATH_DELIMITER + 'HANDLE_NOTIFICATON_DATA';

export const actionCheckNoticeSearch = createAction(ACTION_SEARCH);
export const actionNoticeListSearch = createAction(ACTION_LIST_SEARCH);
export const actionCheckNoticeUpdate = createAction(ACTION_CHECK);

export function* enrolmentCautionSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_CHECK, actionCheckSaga);
    yield takeEvery(ACTION_LIST_SEARCH, actionSearchListSaga);
}

function* actionSearchSaga({ payload: { params } }) {
    const userId = NullCheckUtil.isNotNull(params) ? params.userId : AuthenticationUtil.getUserId();
    const result = yield call(request, {
        method: 'get',
        url: `/api/semester-user/semesters/${SessionStorageUtil.getCurrentSemesterId()}/users/${userId}`,
    });
    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: HANDLE_DATA,
            payload: result,
        });
    }
}

function* actionCheckSaga({ payload: { params, callback } }) {
    const userId = NullCheckUtil.isNotNull(params) ? params.userId : AuthenticationUtil.getUserId();
    const result = yield call(request, {
        method: 'put',
        url: `/api/semester-user/semesters/${SessionStorageUtil.getCurrentSemesterId()}/users/${userId}/check-notice`,
        callback,
    });
    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: HANDLE_DATA,
            payload: result,
        });
    }
}

function* actionSearchListSaga({}) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semester-university/semesters/${SessionStorageUtil.getCurrentSemesterId()}/university-notice`,
    });

    if (result != undefined) {
        yield put({
            type: HANDLE_NOTIFICATON_DATA,
            payload: result,
        });

        console.log('result : ' + result);
    }
}

const initialState = {
    semesterUser: null,
    notification: null,
};

const module = handleActions(
    {
        [HANDLE_DATA]: (state, { payload: semesterUser }) => ({ ...state, semesterUser }),
        [HANDLE_NOTIFICATON_DATA]: (state, { payload: notification }) => ({ ...state, notification }),
    },
    initialState,
);

export default module;
